module.exports = __webpack_public_path__ + "img/Feature.44a75b27.jpg";